import Button, { type ButtonProps } from "@/components/ui/button.tsx";

type Props = Omit<ButtonProps, "asChild"> & { fileUrl: string };
export default function DownloadLink({ fileUrl, children, ...props }: Props) {
    return (
        <Button variant="link" {...props} asChild>
            <a href={fileUrl} download>
                {children}
            </a>
        </Button>
    );
}
